<script setup lang="ts">
import type { IgMediaItem } from '~~/src/core/types';

defineProps<{
  posts: IgMediaItem[];
  loading?: boolean;
}>();
</script>

<template>
  <div class="flex items-center justify-center -space-x-6 sm:-space-x-10">
    <template v-if="loading">
      <FeedPost v-for="n in 4" :key="n" :index="n - 1" loading />
    </template>
    <template v-else>
      <FeedPost
        v-for="(post, index) in posts"
        :key="post.id"
        :index
        :post="post"
      />
    </template>
  </div>
</template>
